const styles = theme => ({
    root: {
        background: 'linear-gradient(90deg, transparent 114px, #151515 0%)',
        width: '100%',
        height: '600px',
        position: 'relative',
        marginTop: '95px',
//        boxShadow: '5px 5px 30px rgba(0, 0, 0, 0.2)',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginBottom: '140px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
            flexDirection: 'column',
            height: 'auto',
            backgroundColor: '#151515',
            paddingBottom: '10px'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            marginTop: '60px',
            marginBottom: '70px'
        }
    },
    span: {
        width: '311px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        height: '655px',
        flexDirection: 'column'
    },
	mobileTicketSwiper: {
		flexDirection: 'row',
		order: 1,
		width: '100%',
		height: 'auto',
		maxWidth: '100%',
		justifyContent: 'flex-start',
		marginTop: '0',
		marginLeft: '0',
		overflow: 'hidden',
		paddingTop:'0',
		paddingLeft:'0',
		paddingRight:'0',
		paddingBottom:'0',
		marginRight:'calc(-50vw + 850px)',
		zIndex: '5',
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
			marginRight:'0',
		}
	},
	mobileTicketSwiper2: {
		flexDirection: 'row',
		order: 1,
		width: '100%',
		height: 'auto',
		maxWidth: '100%',
		justifyContent: 'flex-start',
        zIndex: '5',
        overflow: 'hidden',
        marginTop: 0,
        marginLeft: 0,
        paddingTop: '50px',
        marginRight: 'calc(-50vw + 850px)',
        paddingLeft: '50px',
        paddingRight: '50px',
        paddingBottom: '50px',
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
			marginRight:'0',
            paddingLeft: 'calc(50vw - 155px)',
            paddingRight: 'calc(50vw - 155px)',
            paddingTop:'50px',
            paddingBottom: 0,
		}
	},
    ticketSlide: {
        maxWidth: '265px'
    },
	ticketSlide2: {
        maxWidth: '265px',
        height: 'auto',
        backgroundColor:'#fff',
    	fontSize: 0,
    	boxShadow: '5px 10px 50px rgb(0 0 0 / 30%)',
		transition: 'background-color 0.3s, box-shadow 0.3s',
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
			maxWidth: '150px',
			height: 'auto',
		}
	}
	,
    imageWrap: {
        marginTop: '-125px',
        marginLeft: '50px',
		marginTop: 0,
		marginLeft: 0,
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
            marginTop: 0,
            marginLeft: 0,
            maxHeight: '600px',
           // maxWidth: 'calc(100% - 2rem)',
			maxWidth: '100%',
        }
    },
    fadeImg: {
        opacity: '0.1 !important',
        filter: 'grayscale(1)'
    },
    swiperImg: {
		height: 'auto',
		maxWidth:'100%',
		marginLeft: 0,
    },
    img: {
        height: '100%',
        transition: 'all 0.3s',
        opacity: '1',
        filter: 'none',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
            width: '100%',
            objectFit: 'cover',
        }
    }
})

export default styles